<template>
  <div class="item-description flex-grow">
    <div class="name-price-row">
      <a
        v-if="packageId && !isBookingPortal"
        :href="packagePath"
        class="in-cart-package-link"
        role="button"
      >
        <p class="name font-weight-600"> {{ name }}</p>
      </a>
      <p
        v-else
        class="name font-weight-600"
      >
        {{ name }}
      </p>
      <p class="price">
        {{ price }}
      </p>
    </div>

    <div
      v-if="isHotelItem && item && (item?.hotel_reservations?.[0]?.hotel_check_in_date || item?.contract_check_in)"
      class="quote-hotel-check-in-out-dates"
    >
      <span>{{ reformatCheckIn }},</span> <span>{{ reformatCheckOut }}</span>
    </div>

    <div
      v-if="order && order.order_type!='WebOrder'"
      class="quote-products-modal"
    >
      <QuoteProductsModal
        v-show="isModalVisible"
        :product-names="productNames"
        :name="name"
        @close="closeModal"
      />
    </div>
    <p
      v-if="!isHotelItem"
      class="event-name"
    >
      {{ description() }}
    </p>
    <p
      v-if="candelete == &quot;true&quot;"
      class="delete"
      @click="deleteOrderItem"
    />

    <div
      v-if="ers"
      class="errors"
    >
      <span>{{ ers }}</span>
      <span
        class="delete"
        @click="ers = null"
      />
    </div>
  </div>
</template>

<script>
/* global locale */
import Api from '../../cart_api'
import QuoteProductsModal from './q2oo_modal'
import {mapActions, mapMutations} from 'vuex'
import moment from 'moment'

export default {

  components: {
    QuoteProductsModal
  },

  props: {
    isBookingPortal: {
      default: false,
      type: Boolean
    },
    candelete: {
      default: '',
      type: String
    },
    eventname: {
      default: null,
      type: String
    },
    eventlabel: {
      default: null,
      type: String
    },
    itemid: {
      default: 0,
      type: Number
    },
    name: {
      default: null,
      type: String
    },
    item: {
      default: () => {},
      type: Object
    },
    price: {
      default: null,
      type: String
    },
    packageId: {
      default: 0,
      type: Number
    },
    productNames: {
      default: () => [],
      type: Array
    },
    checkin: {
      default: '',
      type: String
    },
    checkout: {
      default: '',
      type: String
    },
    producttype: {
      default: '',
      type: String
    },
    isHotelItem: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      ers: null,
      isModalVisible: false,
      packagePath: `/${locale}/packages/${this.packageId}/path`
    }
  },

  computed: {
    updating(){
      return this.$store.state.order.loading
    },
    order(){
      return this.$store.state.order.order
    },
    reformatCheckIn() {
      const checkIn = this.item?.hotel_reservations?.[0]?.hotel_check_in_date_yyyy_mm_dd || this.item?.contract_check_in_date_yyyy_mm_dd

      return checkIn ? `${this.$t('h4h.checkIn')}: ${moment(checkIn).format('LL')}` : ''
    },
    reformatCheckOut(){
      const checkOut = this.item?.hotel_reservations?.[0]?.hotel_check_out_date_yyyy_mm_dd || this.item?.contract_check_out_date_yyyy_mm_dd

      return checkOut ? `${this.$t('h4h.checkOut')}: ${moment(checkOut).format('LL')}` : ''
    },
  },

  methods: {
    ...mapActions('order', ['getBackendOrder']),
    ...mapMutations('order', ['updateLoading']),

    deleteOrderItem() {
      if (this.updating) { return }
      this.updateLoading(true)
      this.ers = null
      this.updating = true
      Api.changeOrderItem(this.itemid, 'DELETE', null).then(item => {
        if (item.errors) { this.ers = item.errors }
        this.getBackendOrder().then( () => this.updateLoading(false) )
      })
    },

    closeModal() {
      this.isModalVisible = false
    },
    reformatDates(){
      moment.locale(locale)
      let checkin = moment(this.checkin).format('L')
      let checkout = moment(this.checkout).format('L')
      return `${checkin} - ${checkout}`
    },
    description() {
      switch (this.producttype) {
      case 'ALaCarte':
      case 'Transportation':
        return ''
      case 'Stay':
        if(this.order.in_us){
          return `${this.checkin} - ${this.checkout}`
        } else {
          return this.reformatDates()
        }
      default:
        return this.eventlabel || this.eventname
      }
    }
  }
}
</script>
